
// Renders the active falling block
import { GAME_CONFIG } from '../gameConfig';

// Draw the current active block
export function drawBlock(scene, block) {
  // Clear previous block graphics
  if (block.blocks && block.blocks.length) {
    block.blocks.forEach(graphic => graphic.destroy());
  }
  block.blocks = [];
  
  // Draw each part of the block
  const shape = block.shape;
  const color = block.color;
  
  for (let y = 0; y < 4; y++) {
    for (let x = 0; x < 4; x++) {
      if (shape[y][x] === 1) {
        // Calculate block position on the board
        const blockX = (block.x + x) * GAME_CONFIG.blockSize;
        const blockY = (block.y + y) * GAME_CONFIG.blockSize;
        
        // Create the block graphics
        const blockGraphic = scene.add.rectangle(
          blockX, blockY,
          GAME_CONFIG.blockSize, GAME_CONFIG.blockSize,
          color
        ).setOrigin(0);
        
        // Add border to the block
        const border = scene.add.rectangle(
          blockX, blockY,
          GAME_CONFIG.blockSize, GAME_CONFIG.blockSize,
          0xffffff, 0
        ).setOrigin(0);
        border.setStrokeStyle(2, 0x000000, 0.3);
        
        // Save reference to the graphics
        block.blocks.push(blockGraphic);
        block.blocks.push(border);
      }
    }
  }
}
